export { EDITOR_TYPE, NumericEditor } from "./numericEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/numericEditor/index.mjs
// module id = 448
// module chunks = 1